
import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {  cnAuth } from "../../store/reducers/auth";
import { setTenancyId } from "../../store/reducers/tenancy";
import { dispatch } from "../../store";
import { Box, Grid } from "@mui/material";
import LogoSection from "../../components/Logo";

const CnLogin = () => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const idToken = searchParams.get('id_token');
        const state = searchParams.get('state');
        const storedState = sessionStorage.getItem('State');


        if (!state) {
            console.error('CnLogin: ERROR - No state parameter');
            throw new Error('Hash is null');  // Comment out throw temporarily
            return;
        }

        if (storedState !== state) {
            console.error('CnLogin: ERROR - State mismatch');
            throw new Error('State mismatch');  // Comment out throw temporarily
            return;
        }


        dispatch(cnAuth({ token: idToken }))
            .unwrap()
            .then((returned) => {
                if (returned) {
                    dispatch(setTenancyId(returned.user.tenancyId)).then(() => {
                        navigate('/');
                    });
                } else {
                    console.error('CnLogin: No returned data from cnAuth');
                }
            })
            .catch((err) => {
                console.error('CnLogin: cnAuth FAILED', err);
                navigate('/?error=' + err);
            });
    }, []);
    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "#FFFFFF" }}>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{
                    minHeight: "100vh"
                }}
            >
                <div className="flex items-center justify-center min-h-screen">
                    <Box sx={{ minHeight: "100vh", bgcolor: "#FFFFFF" }}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                                minHeight: "100vh"
                            }}
                        >
                            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                                <LogoSection />
                            </Grid>
                            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                                <div className="flex items-center justify-center min-h-screen">
                                    <div className="text-center">
                                        <h1 className="text-xl mb-4">Authenticating...</h1>
                                        <div
                                            className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full mx-auto"></div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            </Grid>
        </Box>
    );
}

export default CnLogin;
